import type { FC } from 'react';

import { Grid, useDeviceType } from '@packages/shared';
import { ContentExternal } from '@packages/modules';
import type { CmsData } from '@packages/cms-components/interfaces';

import type {
  CategoryNavigationItem,
  ContentInformation,
  SearchSeoApiResponse,
} from '../../api/rest/types';
import { ProductListSeo } from '../ProductListSeo';
import { ProductCategoryNavigationDesktop } from '../ProductCategoryNavigationDesktop';

export type CategoryPageCmsContentOnlyProps = {
  /** the cms content to display */
  cmsContent: CmsData;
  /** the content information */
  contentInformation: ContentInformation;
  /** the category navigation items */
  categoryNavigationItems: CategoryNavigationItem[];
  /** the search seo api response */
  seoResponse?: SearchSeoApiResponse;
};

/**
 * Page content for NoProducts CMS page
 * */
export const CategoryPageCmsContentOnly: FC<CategoryPageCmsContentOnlyProps> = ({
  cmsContent,
  contentInformation,
  categoryNavigationItems,
  seoResponse,
}) => {
  const { isDesktop } = useDeviceType();
  const isLeftNavigation = isDesktop && contentInformation?.hasLeftNavigation;

  return (
    <Grid container spacing={0} padding={0} columns={5}>
      {isLeftNavigation && (
        <Grid item lg={1}>
          <ProductCategoryNavigationDesktop items={categoryNavigationItems} />
        </Grid>
      )}
      <Grid item lg={isLeftNavigation ? 4 : 5} {...(!isLeftNavigation && { width: '100%' })}>
        <ContentExternal data={cmsContent} />

        {seoResponse && <ProductListSeo data={seoResponse} />}
      </Grid>
    </Grid>
  );
};
